<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="34"
    height="34"
    viewBox="0 0 34 34"
  >
    <g id="Icon-MissionBuilder" transform="translate(-1285 -1400)">
      <g id="Group_602" data-name="Group 602" transform="translate(1272 513)">
        <circle
          id="Ellipse_5"
          data-name="Ellipse 5"
          cx="17"
          cy="17"
          r="17"
          transform="translate(13 887)"
          fill="none"
        />
      </g>
      <g
        id="Group_1014"
        data-name="Group 1014"
        transform="translate(27.508 1.049)"
      >
        <path
          id="Subtraction_1"
          data-name="Subtraction 1"
          d="M2.758,6.951H0L5.517,0l5.515,6.949-2.756,0L5.517,3.475,2.758,6.951Z"
          transform="translate(1268.738 1408)"
          :fill="iconColor"
        />
        <path
          id="Subtraction_2"
          data-name="Subtraction 2"
          d="M2.758,6.951H0L5.517,0l5.515,6.949-2.756,0L5.517,3.475,2.758,6.951Z"
          transform="translate(1268.738 1414.951)"
          :fill="iconColor"
        />
      </g>
    </g>
  </svg>
</template>

<script>
  import { computed } from 'vue'
  import { useTheme } from 'vuetify'

  export default {
    name: 'Missions_Icon',
    setup() {
      const theme = useTheme()
      const iconColor = computed(() =>
        theme.global.current.value.dark ? '#CECECE' : '#383935'
      )

      return {
        iconColor,
      }
    },
  }
</script>

<style scoped>
  svg {
    width: 34px;
    height: 34px;
  }
</style>
